import React, { useCallback, useMemo } from "react";
import { useLocation } from "react-router-dom";
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation.js";
import NoteTable from '../../common_nextgen/common_components/NoteScreenComponents/NoteTable.jsx';
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator.js";
import ButtonsSection from '../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection.jsx';
import { ROUTE_PATHS } from "../../common_nextgen/utils/Constants.js";
import useGpiNoteInCouponPatientPayGpiList from "./hooks/useGpiNoteInCouponPatientPayGpiList.js";

const GpiNoteInCouponPatientPayGpiList = () => {
  const location = useLocation();
  const { state: stateVal } = location;
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  const {
    paramsData,
    selectedPriceSchedules = [],
    selectedSchedules = [],
    previousScreen = ROUTE_PATHS.COUPON_PATIENT_PAY_GPI,
    currentIndex: initialIndex = 0,
  } = currentState;
  console.log(
    "states",
    stateVal,
    currentState,
    selectedPriceSchedules,
    initialIndex,
    previousState
  ); const navigateToPage = useCustomNavigate();

  const {
    notes,
    newNotes,
    mode,
    first,
    rows,
    totalRecords,
    currentIndex,
    setMode,
    setFirst,
    setRows,
    setCurrentIndex,
    handleSaveNotes,
    handleChangeNewNote,
    onPageChange,
    exportAsCSV
  } = useGpiNoteInCouponPatientPayGpiList(selectedPriceSchedules, initialIndex);

  const screen_title = "GPI Note in Coupon Patient Pay GPI List";
  const screen_code = "RCCGN001";

  const columns = mode === 'view'
    ? [
      { key: 'cgnNote', header: 'Note' },
      { key: 'chgDate', header: 'Added Date' },
      { key: 'chgTime', header: 'Added Time' },
      { key: 'chgUserName', header: 'User' }
    ]
    : [
      { key: 'cgnNote', header: 'Note' }
    ];

  const handleBack = useCallback(() => {
    if (currentIndex < selectedPriceSchedules.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      navigateToPage(previousScreen, previousState);
    }
  }, [currentIndex, navigateToPage, setCurrentIndex]);

  const handleBackAndSetMode = useCallback(() => {
    handleBack();
    setMode("view");
  }, [handleBack, setMode]);

  const handleModeSwitch = useCallback(() => {
    if (mode === "add") {
      setMode("view");
    } else if (mode === "view") {
      setMode("add");
    }
  }, [mode]);


  const leftButtons = useMemo(
    () => [
      {
        button_label: "Back",
        button_handeler: handleBackAndSetMode,
        button_key: "F12",
      },
      ...(mode === "add"
        ? [
          {
            button_label: "View Note",
            button_handeler: handleModeSwitch,
            button_key: "F6",
          },
        ]
        : []),
    ],
    [mode, handleBackAndSetMode, handleModeSwitch]
  );
  const rightButtons = useMemo(
    () => [
      ...(mode === "view"
        ? [
          {
            button_label: "Add Note",
            button_handeler: handleModeSwitch,
            button_key: "F6",
          },
        ]
        : []),
      { button_label: "Export as CSV", button_handeler: exportAsCSV },
    ],
    [mode]
  );

  const getName = (selectedPriceSchedules, currentIndex) => (
    <>
      <strong>List  </strong>
      {selectedPriceSchedules[currentIndex].cpfGpiListName}
      <span className="info-records">
        <strong>    Description  </strong>
        {selectedSchedules[0].cpfGpiListDescription}
      </span>
      <span className="info-records">
        <strong>    GPI  </strong>
        {selectedPriceSchedules[currentIndex].cpgGenericProductId}
      </span>
      <span className="info-records">
        <strong>    Description  </strong>
        {selectedPriceSchedules[currentIndex].gpiName}
      </span>
    </>
  );

  return (
    <div className="container">
      <ButtonsSection ctaButtons={leftButtons} align="left" />
      <div className="left-aligned-section">
        <div className="header-section">
          <h1>
            {screen_title} - <span className="heading-cod">{screen_code}</span>
          </h1>
        </div>
        <p className="head-name">{getName(selectedPriceSchedules, currentIndex)}</p>
      </div>
      <div className="button-sections">
        <ButtonsSection ctaButtons={rightButtons} align="right" />
      </div>
      <NoteTable
        data={notes}
        columns={columns}
        mode={mode}
        newNotes={newNotes}
        handleChangeNewNote={handleChangeNewNote}
        handleSaveNotes={handleSaveNotes}
      />
      <NextGenPaginator
        first={first}
        rows={rows}
        totalRecords={totalRecords}
        currentPage={first / rows}
        rowsPerPageOptions={[10, 25, 50]}
        onPageChange={onPageChange}
      />
    </div>
  );
};

export default GpiNoteInCouponPatientPayGpiList;  
